<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :class="$style.container"
       :disabled="disabled"
       :style="containerStyle">
    <div :style="childContainerStyle">
      <i class="material-icons"
         :class="$style.icon"
         :disabled="disabled"
         :style="style">
        {{ content }}
      </i>
    </div>
  </div>
</template>

<script>
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseGoogleIcon',
    inheritAttrs: false,
    props: {
      content: { type: String, required: true },
      disabled: { type: Boolean, required: false, default: false },
      iconStyle: { type: Object, required: false, default: null },
    },
    data: function () {
      return {
        attributeNames: ['color', 'fontSize'],
        variableNames: ['color', 'font-size'],
        childContainerStyle: function () {
          return {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            width: '100%',
          };
        },
        containerStyle: {
          boxSizing: 'border-box',
          display: 'inline-block',
        },
        postfixes: ['', 'hover', 'active', 'disabled'],
        style: {
          display: 'block',
          userSelect: 'none',
        },
      };
    },
    created: function () {
      let classObject = getPseudoClassesObject(
        this.$attrs, DefaultPseudoClassAttributeNames,
        '--base-google-icon-container-', DefaultPseudoClassVariableNames,
        this.postfixes);
      let attrs = filterObjectByArray(
        this.$attrs, DefaultPseudoClassAttributeNames);

      this.containerStyle = {
        ...this.containerStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.iconStyle, this.attributeNames,
        '--base-google-icon-', this.variableNames, this.postfixes);
      attrs = filterObjectByArray(
        this.iconStyle, this.attributeNames);

      this.style = {
        ...this.style,
        ...attrs,
        ...classObject,
      };
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--base-google-icon-container-background-color)
    border var(--base-google-icon-container-border)
    border-radius var(--base-google-icon-container-border-radius)
    border-width var(--base-google-icon-container-border-width)
    box-shadow var(--base-google-icon-container-box-shadow)
    cursor var(--base-google-icon-container-cursor)
    font-size var(--base-google-icon-container-font-size)
    height var(--base-google-icon-container-height)
    width var(--base-google-icon-container-width)
    &:hover
      background-color var(--base-google-icon-container-background-color-hover)
      border var(--base-google-icon-container-border-hover)
      border-radius var(--base-google-icon-container-border-radius-hover)
      border-width var(--base-google-icon-container-border-width-hover)
      box-shadow var(--base-google-icon-container-box-shadow-hover)
      cursor var(--base-google-icon-container-cursor-hover)
      font-size var(--base-google-icon-container-font-size-hover)
      height var(--base-google-icon-container-height-hover)
      width var(--base-google-icon-container-width-hover)
    &:active
      background-color var(--base-google-icon-container-background-color-active)
      border var(--base-google-icon-container-border-active)
      border-radius var(--base-google-icon-container-border-radius-active)
      border-width var(--base-google-icon-container-border-width-active)
      box-shadow var(--base-google-icon-container-box-shadow-active)
      cursor var(--base-google-icon-container-cursor-active)
      font-size var(--base-google-icon-container-font-size-active)
      height var(--base-google-icon-container-height-active)
      width var(--base-google-icon-container-width-active)
    &[disabled]
      background-color var(--base-google-icon-container-background-color-disabled)
      border var(--base-google-icon-container-border-disabled)
      border-radius var(--base-google-icon-container-border-radius-disabled)
      border-width var(--base-google-icon-container-border-width-disabled)
      box-shadow var(--base-google-icon-container-box-shadow-disabled)
      cursor var(--base-google-icon-container-cursor-disabled)
      font-size var(--base-google-icon-container-font-size-disabled)
      height var(--base-google-icon-container-height-disabled)
      width var(--base-google-icon-container-width-disabled)

  .icon
    color var(--base-google-icon-color)
    font-size var(--base-google-icon-font-size)
    &:hover
      color var(--base-google-icon-color-hover)
      font-size var(--base-google-icon-font-size-hover)
    &:active
      color var(--base-google-icon-color-active)
      font-size var(--base-google-icon-font-size-active)
    &[disabled]
      color var(--base-google-icon-color-disabled)
      font-size var(--base-google-icon-font-size-disabled)
</style>
